var map = {
	"./1.png": 74,
	"./10.png": 75,
	"./2.png": 76,
	"./3.png": 77,
	"./4.png": 78,
	"./5.png": 79,
	"./6.png": 80,
	"./7.png": 81,
	"./8.png": 82,
	"./9.png": 83,
	"./background/1.png": 84,
	"./background/10.png": 85,
	"./background/2.png": 86,
	"./background/3.png": 87,
	"./background/4.png": 88,
	"./background/5.png": 89,
	"./background/6.png": 90,
	"./background/7.png": 91,
	"./background/8.png": 92,
	"./background/9.png": 93,
	"./unrevealed_transparent.png": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73;